export default {
  RED_BRAND: 'redbrand',
};
